import Protected from "@/pages/protected";
import { Outlet, RouteObject } from "react-router-dom";
import CampaignRoutes from "./campaign";
import CardRoute from "./card";
import DialerPicklistsRoute from "./picklists";
import WorkflowRoute from "./workflow";

/**
 * `/outils/campagnes` — the bespoke screens of the calling-campaign engine: the graph
 * editor, the version lineage, the comparator, the simulator, a card's timeline, and
 * the deploy-preview resource route the dialogs still post to. Campaign list, detail
 * and Operations live at `/dialer-campaigns`, served by `sf_like` from `CampaignConfig`;
 * `/outils/campagnes/:code` redirects onto that Operations tab.
 *
 * Read access follows the `dialer.workflow` read right of the profile matrix
 * (`user.can_open_dialer`); writing is gated server-side by the same matrix
 * (`dialer.workflow` / `dialer.campaign` update), mirrored by the `permissions`
 * block of each projection.
 */
const DialerRoute: RouteObject = {
    path: "campagnes",
    element: (
        <Protected allowed={user => Boolean(user.can_open_dialer)}>
            <Outlet />
        </Protected>
    ),
    children: [...CampaignRoutes, CardRoute, WorkflowRoute, DialerPicklistsRoute]
};

export default DialerRoute;
